import CleverpushChat from '../../cleverpush-chat';

require('./stickyButton.scss');

export default class StickyButton {
  constructor(config) {
    this.config = config;

    this.stickyWidget = document.createElement('div');
    this.stickyWidget.className = 'cleverpush-sticky-widget-btn-container';
    document.body.appendChild(this.stickyWidget);

    this.chatWidgetContainer = document.createElement('div');
    this.chatWidgetContainer.className = 'cleverpush-sticky-chat-widget-container';
    document.body.appendChild(this.chatWidgetContainer);

    this.chatWidgetHeader = document.createElement('div');
    this.chatWidgetHeader.className = 'cleverpush-chat-widget-header';
    this.chatWidgetContainer.appendChild(this.chatWidgetHeader);
    this.chatWidget = document.createElement('div');
    this.chatWidget.className = 'cleverpush-sticky-widget';
    this.chatWidgetContainer.appendChild(this.chatWidget);
    this.themeColor = this.config.chatWidgetThemeColor || this.config.chatStylingOptions?.chatButtonColor || '#54B1C4';
    this.buttonName = this.config.chatWidgetButtonName || 'Support';
    this.subscriptionId = this.fetchSubscriptionId();
    this.isOpened = false;
  }

  fetchSubscriptionId = () => {
    let subscriptionId = '';
    let guestSubscriptionId = '';
    try {
      subscriptionId = localStorage.getItem('cleverpush-subscription-id');
      guestSubscriptionId = localStorage.getItem('cleverpush-guest-subscription-id');
    } catch (ignored) { }
    if (subscriptionId) {
      return subscriptionId;
    }
    if (guestSubscriptionId) {
      return guestSubscriptionId;
    }
    return 'preview';
  }

  renderChatWidgetHeader = () => {
    this.chatWidgetHeader.innerHTML = `
      <div class="cleverpush-chat-header-title">${this.buttonName}</div>
      <div id="cleverpush-widget-close-icon-id" class="cleverpush-chat-header-close-btn">
      <svg width="16" height="16" viewBox="0 0 16 16" data-garden-id="buttons.icon" data-garden-version="8.13.0" theme="[object Object]" class="sc-bwzfXH hDrfMZ"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M3 8h10"></path></svg>
      </div>
    `;

    const widgetCloseBtn = document.getElementById('cleverpush-widget-close-icon-id');
    if (widgetCloseBtn) {
      widgetCloseBtn.style.cursor = 'pointer';
      widgetCloseBtn.addEventListener('click', () => {
        this.eject();
      });
    }
  }

  render = () => {
    const widgetButton = document.createElement('button');
    widgetButton.id = 'cleverpush-widget-button';
    widgetButton.classList = 'cleverpush-sticky-widget-button';

    if (this.config.chatWidgetButtonIconUrl) {
      widgetButton.classList.add('cleverpush-support-icon');
      widgetButton.innerHTML = `<img src="${this.config.chatWidgetButtonIconUrl}" alt="support" />`;
    } else {
      widgetButton.style.borderRadius = '50px';
    }

    if (this.config.chatWidgetButtonName) {
      widgetButton.classList.add('cleverpush-support-button');
      widgetButton.style.backgroundColor = this.themeColor;
      widgetButton.innerHTML = this.config.chatWidgetButtonName;
    }

    this.chatWidgetHeader.style.background = this.themeColor;
    this.stickyWidget.append(widgetButton);

    if (widgetButton) {
      widgetButton.addEventListener('click', () => {
        if (this.isOpened) {
          this.eject();
        } else {
          this.isOpened = true;
          this.chatWidget.classList.add('active');
          this.chatWidgetContainer.classList.add('active');
          this.stickyWidget.classList.add('active');
          this.chatWidgetHeader.classList.add('active');
          this.renderChatWidgetHeader();
          new CleverpushChat(this.subscriptionId, window.CleverPush.config, this.isOpened);
        }
      });
    }
  }

  eject = () => {
    this.isOpened = false;
    this.chatWidget.innerHTML = '';
    this.chatWidget.classList.remove('active');
    this.stickyWidget.classList.remove('active');
    this.chatWidgetContainer.classList.remove('active');
    this.chatWidgetHeader.classList.remove('active');
    this.chatWidgetHeader.innerHTML = '';
  }
}
